import { render, staticRenderFns } from "./SchemaSimpleTable.vue?vue&type=template&id=ca935830&scoped=true"
import script from "./SchemaSimpleTable.vue?vue&type=script&lang=js"
export * from "./SchemaSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./SchemaSimpleTable.vue?vue&type=style&index=0&id=ca935830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca935830",
  null
  
)

export default component.exports